require('../styles/index.css');
require('../styles/cookiePolicy.css');

import { observer } from 'mobx-react';
import { Component, Fragment } from 'react';

import App from './App';
import Shell from './Shell';

export interface RootProps {
  app: App;
  onComponentDidMount?: () => void;
}

@observer
class Root extends Component<RootProps> {
  public componentDidMount() {
    if (this.props.onComponentDidMount) {
      this.props.onComponentDidMount();
    }
  }

  public render() {
    const { app } = this.props;

    return (
      <Fragment>
        <Shell app={app} />
      </Fragment>
    );
  }
}

export default Root;
